// File: src/pages/SeoManagementPage.js
// This page is updated to remove the duplicate Analytics Integration section.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function SeoManagementPage() {
  const [globalTitle, setGlobalTitle] = useState('R.A.W. Fitness - Rise and Win');
  const [globalDescription, setGlobalDescription] = useState('Your journey to a stronger, healthier you starts now. Unleash your potential with R.A.W. Fitness.');
  const [ogTitle, setOgTitle] = useState('R.A.W. Fitness - Rise and Win');
  const [ogDescription, setOgDescription] = useState('Join our community and start your fitness journey today!');
  const [ogImage, setOgImage] = useState('https://rawfit.co.za/og-image.png');
  const [robotsTxt, setRobotsTxt] = useState('User-agent: *\nAllow: /\n\nSitemap: https://rawfit.co.za/sitemap.xml');
  
  const [redirects, setRedirects] = useState([
    { id: 1, from: '/old-workout-page', to: '/articles/new-10-minute-hiit-workout' }
  ]);
  const [newRedirect, setNewRedirect] = useState({ from: '', to: '' });

  const handleAddRedirect = () => {
    if (newRedirect.from && newRedirect.to) {
        setRedirects([...redirects, { ...newRedirect, id: Date.now() }]);
        setNewRedirect({ from: '', to: '' });
    }
  };

  const handleDeleteRedirect = (id) => {
    setRedirects(redirects.filter(r => r.id !== id));
  };

  const handleSave = () => {
    alert('SEO settings saved successfully! (Simulation)');
  };

  const handleGenerateSitemap = () => {
    alert('Sitemap regeneration triggered! (Simulation)');
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <header className="bg-black shadow-md">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <img src="/Logo.png" alt="R.A.W. Fitness Logo" className="h-12 w-auto" />
            <h1 className="text-xl font-bold text-lime">SEO Management</h1>
          </div>
          <nav>
            <Link to="/admin" className="text-white hover:text-lime transition duration-300">Back to Dashboard</Link>
          </nav>
        </div>
      </header>
      <main className="container mx-auto px-6 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          
          {/* Left Column */}
          <div className="space-y-8">
            {/* Global Meta Defaults */}
            <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
              <h2 className="text-3xl font-bold mb-6 text-magenta">Global Meta Defaults</h2>
              <div className="space-y-6">
                <div>
                  <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="globalTitle">Default Meta Title</label>
                  <input id="globalTitle" type="text" value={globalTitle} onChange={(e) => setGlobalTitle(e.target.value)} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta" />
                </div>
                <div>
                  <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="globalDescription">Default Meta Description</label>
                  <textarea id="globalDescription" rows="3" value={globalDescription} onChange={(e) => setGlobalDescription(e.target.value)} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta"></textarea>
                </div>
              </div>
            </div>

            {/* Social Sharing Defaults */}
            <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
              <h2 className="text-3xl font-bold mb-6 text-magenta">Social Sharing Defaults (Open Graph)</h2>
              <div className="space-y-6">
                <div>
                  <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="ogTitle">Social Share Title (og:title)</label>
                  <input id="ogTitle" type="text" value={ogTitle} onChange={(e) => setOgTitle(e.target.value)} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta" />
                </div>
                <div>
                  <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="ogDescription">Social Share Description (og:description)</label>
                  <textarea id="ogDescription" rows="3" value={ogDescription} onChange={(e) => setOgDescription(e.target.value)} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta"></textarea>
                </div>
                 <div>
                  <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="ogImage">Social Share Image URL (og:image)</label>
                  <input id="ogImage" type="text" value={ogImage} onChange={(e) => setOgImage(e.target.value)} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta" />
                   <p className="text-xs text-gray-500 mt-1">Recommended size: 1200x630 pixels.</p>
                </div>
              </div>
            </div>

            {/* Schema Markup */}
            <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
                <h2 className="text-3xl font-bold mb-6 text-magenta">Schema Markup (Organization)</h2>
                <p className="text-gray-400 mb-4">This helps Google understand your brand information for Knowledge Graph results.</p>
                <div className="space-y-6">
                    <div>
                        <label className="block text-gray-400 text-sm font-bold mb-2" htmlFor="orgName">Organization Name</label>
                        <input id="orgName" type="text" defaultValue="R.A.W. Fitness" className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-gray-600 focus:border-magenta" />
                    </div>
                </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-8">
            {/* Robots.txt Management */}
            <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
              <h2 className="text-3xl font-bold mb-6 text-lime">robots.txt Management</h2>
              <textarea id="robotsTxt" rows="8" value={robotsTxt} onChange={(e) => setRobotsTxt(e.target.value)} className="appearance-none block w-full bg-gray-900 text-gray-300 font-mono border border-gray-600 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-black focus:border-lime"></textarea>
            </div>

            {/* Sitemap Management */}
            <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
              <h2 className="text-3xl font-bold mb-6 text-lime">Sitemap Management</h2>
              <button onClick={handleGenerateSitemap} className="w-full bg-lime text-black font-bold py-3 px-4 rounded-lg hover:bg-opacity-80 transition duration-300 glow-lime">Regenerate sitemap.xml</button>
            </div>
            
            {/* Redirection Management */}
            <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
                <h2 className="text-3xl font-bold mb-6 text-lime">Redirection (301)</h2>
                <div className="space-y-2 mb-4">
                    {redirects.map(r => (
                        <div key={r.id} className="flex items-center justify-between bg-gray-700 p-2 rounded">
                            <code className="text-sm">{r.from} &rarr; {r.to}</code>
                            <button onClick={() => handleDeleteRedirect(r.id)} className="text-red-500 hover:text-red-400">&times;</button>
                        </div>
                    ))}
                </div>
                <div className="flex items-center gap-4">
                    <input type="text" placeholder="/from-url" value={newRedirect.from} onChange={(e) => setNewRedirect({...newRedirect, from: e.target.value})} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-gray-600 focus:border-lime" />
                    <input type="text" placeholder="/to-url" value={newRedirect.to} onChange={(e) => setNewRedirect({...newRedirect, to: e.target.value})} className="appearance-none block w-full bg-gray-700 text-white border border-gray-600 rounded py-2 px-3 leading-tight focus:outline-none focus:bg-gray-600 focus:border-lime" />
                    <button onClick={handleAddRedirect} className="bg-lime text-black font-bold py-2 px-4 rounded-lg hover:bg-opacity-80 transition">+</button>
                </div>
            </div>
          </div>
        </div>
        
        {/* Save Button */}
        <div className="mt-8 text-right">
          <button onClick={handleSave} className="bg-magenta text-black font-bold py-3 px-8 rounded-lg hover:bg-opacity-80 transition duration-300 glow-magenta">
            Save All SEO Settings
          </button>
        </div>
      </main>
    </div>
  );
}

export default SeoManagementPage;
